import { Box, BoxProps } from '@mui/material'

import BackgroundLg from 'assets/images/background_welcome_lg.png'
import BackgroundMd from 'assets/images/background_welcome_md.png'
import BackgroundSm from 'assets/images/background_welcome_sm.png'
import BackgroundXl from 'assets/images/background_welcome_xl.png'

import { Theme, styled } from '@mui/material/styles'

export const Background2 = styled(Box)<BoxProps>((props) => {
  const theme: Theme = props.theme as unknown as Theme
  return {
    width: '100%',
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundImage: `url(${BackgroundXl})`,
    [theme.breakpoints.down('lg')]: {
      backgroundImage: `url(${BackgroundLg})`,
    },
    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${BackgroundMd})`,
    },
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${BackgroundSm})`,
    },
  }
})
